/*
Reusable components that can be used to style modals using the theme of the app
*/

import styled from "styled-components";
import { readableColor } from "polished";
import { Modal } from "react-bootstrap";

export const ThemedModalHeader = styled(Modal.Header)`
    color: ${(props: any) => readableColor(props.theme[props.variant ?? 'primary'])};
    background: linear-gradient(to bottom, ${(props: any) => props.theme.primary}, ${(props: any) => props.theme.secondary});

    & > button.btn-close {
        color: #ffffff;
        filter: brightness(0) invert(1);
        &:hover {
            color: inherit;
        }
    }
`;

const ThemedModal = {
    Header: ThemedModalHeader
};

export default ThemedModal;